import React from 'react'

const Purchase = (): JSX.Element => {
  return <div>search</div>
}

export default Purchase
